module.exports = __webpack_public_path__ + "img/09.e29769f2.jpg";